import React from "react";
import { useHistory } from "react-router-dom";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const BreachIQNoScore = () => {
    const history = useHistory();
    const { t: tLang, i18n: i18nLang } = useTranslation();

    return (
        <div className="box">
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-text has-actions">
                        <h2 className="brach-text-color">BreachIQ™</h2>
                    </div>
                </div>
            </div>
            <div className="box-content">
                <div className="row widget-breach-border">
                    <div className="row widget-no-breach-title">
                        <div className="col-xs-12 col-sm-8">
                            <div className="box-header padding-left-5rem margin-left-xs-3">
                                <div className="box-title-container" style={{ marginBottom: "unset" }}>
                                    <div className="title-icon" aria-hidden="true" style={{ width: 41, height: 41 }}>
                                        <RenderIcons iconName="breach-search" />
                                    </div>
                                    <div className="box-title-text" style={{ marginTop: "0.25rem" }}>
                                        <h2 className="breach-section-title label">{tLang("dashboard.breachIq.heading")} </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <div
                                className="search-link"
                                onClick={() => {
                                    history.push("/breaches/search-breaches");
                                }}
                            >
                                <span>{tLang("dashboard.breachIq.searchLinkText")}</span>
                                <span>
                                    <em className="las la-angle-right" style={{ color: "#306e91" }}></em>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row widget-no-breach-description">
                        <div className="col-xs-12" style={{ paddingTop: "unset", paddingBottom: "1.125rem" }}>
                            <span>{tLang("dashboard.breachIq.description")} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreachIQNoScore;
